import { Laws } from "@/data-source/types";
import { TWENTY_TWO } from "@/data-source/laws/2022";
import { TWENTY_THREE } from "@/data-source/laws/2023";
import { TWENTY_FOUR } from "@/data-source/laws/2024";
import { TWENTY_SIX } from "@/data-source/laws/2026";
import { LawYear } from "@/types/salary";
import { TWENTY_FIVE } from "./laws/2025";

export const laws: Laws = {
    [LawYear.TWENTY_TWO]: TWENTY_TWO,
    [LawYear.TWENTY_THREE]: TWENTY_THREE,
    [LawYear.TWENTY_FOUR]: TWENTY_FOUR,
    [LawYear.TWENTY_FIVE]: TWENTY_FIVE,
    [LawYear.TWENTY_SIX]: TWENTY_SIX,
};
